<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmLighthuose"
      :title="$lang.Lighthouse.TitleFormsLighthouse"
      :showHelp="true"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">

      <div class="form-group row">
        <div class="col-md-4">
          <label for="cbxArea"><small class="text-danger">*</small> {{$lang.Insurer.LabelArea}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.areaID.value"
                          :options="form.areaID.options"
                          :state="form.areaID.state"
                          class="mb-3"
                          name="cbxArea"
                          @change="onChangeArea">
                <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxInsurer"><small class="text-danger">*</small> {{$lang.Lighthouse.Insurer}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.insuranceID.value"
                              :options="form.insuranceID.options"
                              :state="form.insuranceID.state"
                              class="mb-3"
                              name="cbxInsurer">
                <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="cbxStage"><small class="text-danger">*</small> {{$lang.Lighthouse.Stage}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.stageID.value"
                              :options="form.stageID.options"
                              :state="form.stageID.state"
                              class="mb-3"
                              name="cbxStage">
                <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>

      </div>
      <div class="form-group row">
        <div class="col-md-4">
          <label for="cbxSchedulingType"><small v-show="form.schedulingTypeID.required" class="text-danger">*</small> {{$lang.Lighthouse.SchedulingContact}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.schedulingTypeID.value"
                          :options="form.schedulingTypeID.options"
                          :state="form.schedulingTypeID.state"
                          class="mb-3"
                          name="cbxSchedulingType">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
         <div class="col-md-8">
          <label for="txtNameLighthouse"><small class="text-danger">*</small> {{$lang.Lighthouse.NameLighthouse}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          name="txtNameLighthouse"
                          :placeholder="$lang.Lighthouse.PlaceholderLighthouseName"
                          v-model="form.name.value"
                          :size="form.name.maxlength"
                          :required="form.name.required"
                          :state="form.name.state"></b-form-input>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-2">
          <label for="txtName"> {{$lang.Lighthouse.GreenStart}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'00:00'"
                          :disabled=true></b-form-input>
            <span class="input-group-addon"><i class="fa fa-clock-o text-success text-bold"></i></span>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtGreen"><small class="text-danger">*</small> {{$lang.Lighthouse.GreenEnd}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'00:00'"
                          v-model="form.green.value"
                          :size="form.green.maxlength"
                          :required="form.green.required"
                          :state="form.green.state"
                          v-mask="['##:##']"></b-form-input>
            <span class="input-group-addon"><i class="fa fa-long-arrow-down text-success text-bold"></i></span>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtName"> {{$lang.Lighthouse.YellowStart}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'00:00'"
                          v-model="StartYellow"
                          :disabled=true></b-form-input>
            <span class="input-group-addon"><i class="fa fa-long-arrow-up text-warning text-bold"></i></span>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtGreen"><small class="text-danger">*</small> {{$lang.Lighthouse.YellowEnd}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'00:00'"
                          v-model="form.yellow.value"
                          :size="form.yellow.maxlength"
                          :required="form.yellow.required"
                          :state="form.yellow.state"
                          v-mask="['##:##']"></b-form-input>
            <span class="input-group-addon"><i class="fa fa-long-arrow-down text-warning text-bold"></i></span>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtName"> {{$lang.Lighthouse.RedStart}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'00:00'"
                          v-model="StartRed"
                          :disabled=true></b-form-input>
            <span class="input-group-addon"><i class="fa fa-long-arrow-up text-danger text-bold"></i></span>
          </div>
        </div>
        <div class="col-md-2">
          <label for="txtRed"><small class="text-danger">*</small> {{$lang.Lighthouse.RedEnd}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'00:00'"
                          v-model="form.red.value"
                          :size="form.red.maxlength"
                          :required="form.red.required"
                          :state="form.red.state"
                          v-mask="['##:##']"></b-form-input>
            <span class="input-group-addon"><i class="fa fa-clock-o text-danger text-bold"></i></span>
          </div>
        </div>
    </div>

    </Forms>

    <Tables ref="tableGrid"
            :columns="[$lang.Lighthouse.DataTable.Name,
                       $lang.Lighthouse.DataTable.Area,
                       $lang.Lighthouse.DataTable.Insurer,
                       $lang.Lighthouse.DataTable.Stage,
                       $lang.Common.DataTable.Status,
                       $lang.Common.DataTable.ActionDate,
                       $lang.Common.DataTable.AccountAction,
                       $lang.Common.DataTable.Actions]"
            :showSearch="true"
            :showPrint="true"
            :showDownload="true"
            :showFullscreen="true"
            v-on:Load="onLoad">
      <tr v-for="(obj, index) in this.objList" :key="index">
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.name" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.area.name" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.insurance.name" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.stage.name" />
        <TableColumn :IsStatus="true"   v-on:Edit="onEdit(obj)" :status="obj.status" />
        <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateUpdate" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.accountUserNameUpdate" />
        <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>

   </div>
</template>
<script>
import Lighthouse from './lighthouse.js'

export default Lighthouse
</script>



// WEBPACK FOOTER //
// src/views/private/regulation/lighthouse/lighthouse.vue